(function defaultScript($, Drupal) {
  Drupal.behaviors.default_list = {
    attach(context) {
      function advancedExposedFormTrigger() {
        var advancedExposedFormButton = $('button.default-exposed-form__button');
        var advancedExposedForm = $('.advanced-exposed-form');

        advancedExposedFormButton.unbind().click(function() {
          advancedExposedForm.toggleClass('advanced-exposed-form--active');
        });
      }
      advancedExposedFormTrigger();

      if (location.hash == '#adv') {
        $('.advanced-exposed-form').addClass('advanced-exposed-form--active');
      }
    }
  };
})(jQuery, Drupal);